<template>
  <div
      v-loading="loading"
      class="one-off-reasons flex flex-auto flex-col">
    <div class="title">
      Select one-off reason
    </div>
    <div class="flex">
      <span class="flex-shrink description">
        Please select a reason for product one-off.
      </span>
      <RefreshButton
          class="flex-shrink"
          style="padding: 0; margin-left: 0.5rem"
          :text="false"
          @click="loadReasons" />
    </div>
    <div>
      <div class="flex flex-row gap-16">
        <div
            class="flex-1 input-label"
            style="margin-top: 48px; margin-bottom: 8px">
          Reason Group
        </div>
      </div>
      <div class="flex flex-row gap-16">
        <div class="select-one-off-reason">
          <el-select
              v-model="selectedReasonGroup"
              class="reason-group-select"
              :placeholder="selectedReasonGroup.toString()"
              popper-class="select-one-off-reason-dropdown"
              @change="sendReasonGroup">
            <el-option
                v-for="group in reasonGroups"
                :key="group.id"
                class="select-one-off-reason-option"
                :label="group.value"
                :value="group.id">
              <span
                  style="float: left; color: #424242"
                  :class="{'highlight-selection': selectedReasonGroup === group.id}">{{ group.value }}</span>
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div>
      <div class="flex flex-row gap-16">
        <div
            class="flex-1 input-label"
            style="margin-top: 40px; margin-bottom: 8px">
          One-off Reason
        </div>
      </div>
      <div class="flex flex-row gap-16">
        <div class="select-one-off-reason">
          <el-select
              :value="reasonSelectionText"
              :disabled="!isGroupSelected"
              class="reason-group-select"
              placeholder="Select the one-off reason"
              popper-class="select-one-off-reason-dropdown"
              @change="sendReason">
            <el-option
                v-for="reason in oneOffReasons"
                :key="reason.id"
                class="select-one-off-reason-option"
                :label="reason.text"
                :value="reason.id">
              <span
                  style="float: left; color: #424242"
                  :class="{'highlight-selection': selectedOneOffReason === reason.id}">{{ reason.value }} - {{ reason.text }} <span
                      v-show="reason.return_label"
                      style="color: #6e6e6e !important;">With Return Label</span>
              </span>
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RefreshButton from "@/containers/Customer/RefreshButton.vue";

export default {
  name: "OneOffReasons",
  components: { RefreshButton },
  props: {
    device: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      group: 0,
      oneOff: 1,
      selectedGroup: -1,
      selectedReason: -1,
      selectedOneOffReason: -1,
      selectedReasonGroup: -1,
      isGroupSelected: false,
      reasonGroups: [],
      allOneOffReasons: [],
      oneOffReasons: [],
      loading: false,
      selectedReasonCode: "",
      selectedReasonReturnLabel: false,
      selectedReasonName: "",
      isSelectedReturnLabel: false,
    };
  },
  computed: {
    deviceKind() {
      return this.device.type || this.device.kind || this.device.product.kind;
    },
    reasonSelectionText() {
      if (this.selectedReasonCode === "") return this.selectedReasonName;
      else if (this.selectedReasonReturnLabel)
        return (
          this.selectedReasonCode +
          " - " +
          this.selectedReasonName +
          " (With Return Label)"
        );
      else return this.selectedReasonCode + " - " + this.selectedReasonName;
    },
  },
  mounted() {
    console.log("this.device", this.device);
    this.clearSelectedReason();
    this.loadReasons();
  },
  methods: {
    setDefaultValues() {
      if (this.selectedGroup === -1 && this.selectedReason === -1) {
        this.selectedReasonGroup = "Select the reason group";
        this.selectedReasonName = "Select the one-off reason";
        this.oneOffReasons = "";
        this.selectedReasonCode = "";
        this.selectedReasonReturnLabel = false;
        this.isGroupSelected = false;
      } else {
        this.setReasonGroup(this.selectedGroup);
        this.setReason(this.selectedReason);
      }
    },
    setReason(selectedReason) {
      this.selectedOneOffReason = selectedReason;
      let name = this.oneOffReasons.filter(
        (reason) => reason.id === selectedReason
      );
      this.selectedReasonCode = name[0].value.toString();
      this.selectedReasonReturnLabel = name[0].return_label;
      this.selectedReasonName = name[0].text;
      this.isSelectedReturnLabel = name[0].return_label;
    },
    sendReason(selectedReason) {
      this.setReason(selectedReason);
      this.emitSelectedReasons(true);
    },
    setReasonGroup(group) {
      this.selectedReasonGroup = group;
      this.isGroupSelected = true;
      this.oneOffReasons = this.getReasonFromGroups(this.selectedReasonGroup);
    },
    sendReasonGroup(group) {
      this.selectedReasonName = "Select the one-off reason";
      this.selectedOneOffReason = "";
      this.selectedReasonCode = "";
      this.selectedReasonReturnLabel = false;
      this.setReasonGroup(group);
      if (this.oneOffReasons.length === 0) {
        this.emitSelectedReasons(true);
      } else {
        this.emitSelectedReasons(false);
      }
    },
    getReasonFromGroups(group) {
      return this.allOneOffReasons.filter(
        (reason) =>
          reason.reason_group_id === group &&
          reason.kinds.includes(this.deviceKind)
      );
    },
    emitSelectedReasons(allowNext) {
      this.$emit("selected-group-and-reason", {
        group: this.selectedReasonGroup,
        reason: this.selectedOneOffReason,
        name: this.selectedReasonName,
        label: this.isSelectedReturnLabel,
        allowNext: allowNext,
      });
    },
    clearSelectedReason() {
      this.selectedGroup = -1;
      this.selectedReason = -1;
      this.emitSelectedReasons(false);
    },
    loadReasons() {
      this.loading = true;
      axios
        .get("/v2/reasons.json?active=true")
        .then((result) => {
          let groups = result.data.groups;
          this.allOneOffReasons = result.data.reasons;
          // console.log("this.allReplacementReasons", this.allReplacementReasons);
          groups = groups.filter((group) => group.key === "one_off");
          console.log("groups", groups);
          if (this.deviceKind) {
            groups = groups.filter(
              (group) =>
                !!this.allOneOffReasons.find(
                  (reason) =>
                    reason.reason_group_id === group.id &&
                    reason.kinds.includes(this.deviceKind)
                )
            );
          }
          this.reasonGroups = groups;
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
          this.setDefaultValues();
        });
    },
  },
};
</script>

<style>
.one-off-reasons {
  gap: 8px;
}
.one-off-reasons .title {
  height: 36px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  display: flex;
  align-items: flex-end;
  color: #424242;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

.one-off-reasons .description {
  height: 24px;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
  margin: 0 !important;
}
.one-off-reasons .reason-group-select {
  display: flex;
  width: 100%;
  height: 48px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: #424242;
}
.select-one-off-reason {
  display: flex;
  align-self: center;
  width: 644px !important;
}
.highlight-selection {
  color: #1998d5 !important;
  font-weight: bold;
}
</style>
